import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import async from 'async';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';

import UserService from 'services/UserService';
import { FormGroup, Text, Textarea, Select } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { required, equalTo } from 'constants/InputErrors';

class ChangePassword extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      incidentSubTypes:[],
      incidentTypes:[],
      landmark: null,
      showPassword: false,
      showPasswordConfirm: false,
    };

    this.submitForm = this.submitForm.bind( this );
    this.toggleShowPassword = this.toggleShowPassword.bind(this);
    this.toggleShowPasswordConfirm = this.toggleShowPasswordConfirm.bind(this);
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.setState( { landmark: null } );
      //this.getData()
    }
  }

  toggleShowPassword = () => {
    const { showPassword } = this.state;
    this.setState({showPassword: !showPassword});
  }
  toggleShowPasswordConfirm = () => {
    const { showPasswordConfirm } = this.state;
    this.setState({showPasswordConfirm: !showPasswordConfirm});
  }
  submitForm2 = ( data ) => {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    UserService.updateUserPassword( data ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      toggleAlertError( <Translate id="dataSaved"/> );
      this.props.history.push( '/' )
    } )
  };

  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading, userId } = this.props;
    const dataToSend = {};
    toggleLoading( true );

    // dataToSend.channel = userId.value;
    dataToSend.password = data.newPassword;
    UserService.adminChangePassword(userId.value, dataToSend ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      toggleAlertError( <Translate id="dataSaved"/> );
      //onReloadData( channel.id );
      onClose()
    } )
  }

  render() {
    const { onClose, open, activeAccount, userId } = this.props;
    const { showPassword, showPasswordConfirm } = this.state;
    const SearchButton = () => (
      <IconButton>
        <SearchIcon />
      </IconButton>
      )
    return (
      <Modal closeOnEsc={false}
             closeOnOverlayClick={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="changePassword"/></h5>

        <Form
                  onSubmit={this.submitForm}
                  validate={values => {
                    return {
                      newPassword: required( values.newPassword ),
                      passwordConfirmation: this.entityId ? null
                        : required( values.passwordConfirmation ) ? required( values.passwordConfirmation )
                          : equalTo( values.passwordConfirmation, values.newPassword, 'Password' )
                    }
                  }}
                >
                  {( { submitForm } ) =>
                    <form onSubmit={submitForm}>
                      <div className="form-group mt-3">
                      <i className="fa fa-user"/> <b>{userId.original.username}</b> ({userId.original.email})
                      </div>

                      <div className="form-group mt-3">
                        <Text field="newPassword"
                          className="form-control"
                          placeholder="password"
                          type={showPassword ? "text" : "password" }
                          append={true}
                          suffix={showPassword ? <i onClick={this.toggleShowPassword} className="fa fa-eye"/> : <i onClick={this.toggleShowPassword} className="fa fa-eye-slash"/> }

                        />
                      </div>

                      <div className="form-group mt-3">
                        <Text
                          field="passwordConfirmation"
                          className="form-control"
                          placeholder="passwordConfirmation"
                          type={showPasswordConfirm ? "text" : "password" }
                          append={true}
                          suffix={showPasswordConfirm ? <i onClick={this.toggleShowPasswordConfirm} className="fa fa-eye"/> : <i onClick={this.toggleShowPasswordConfirm} className="fa fa-eye-slash"/> }

                        />
                      </div>

                      <div className="text-right mt-3">
                        <button type="submit" className="btn btn-info text-uppercase">
                          <Translate id="changePassword"/>
                        </button>
                      </div>
                    </form>
                  }
                </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( ChangePassword );




// WEBPACK FOOTER //
// ./routes/app/routes/configuration/users/ChangePassword/index.js